export default function SubscriptionsPageLoader() {
	return (
		<div className="plans-loading" role="status" aria-label="Loading subscription plans">
			<span className="sr-only">Loading subscription plans…</span>
			<div className="plans-skeleton-heading" aria-hidden="true" />
			<div className="plans-desktop-comparison plans-table-skeleton" aria-hidden="true">
				{Array.from({ length: 6 }, (_, row) => <div key={row}>{[1, 2, 3].map((column) => <span key={column} />)}</div>)}
			</div>
			<div className="plans-mobile-cards plans-cards" aria-hidden="true">{[1, 2].map((item) => <div className="plans-skeleton" key={item}><span /><span /><span /><span /><span /></div>)}</div>
		</div>
	);
}
